import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslatorService } from 'src/app/translator.service';

@Component({
  selector: 'app-question',
  templateUrl: './question.component.html',
  styleUrls: ['./question.component.scss'],
})
export class QuestionComponent implements OnInit {

  @Input() questionData;
  @Input() activeUser;
  
  @Output() onQuestionClick: EventEmitter<any> = new EventEmitter<any>();
  public rightAnswer = "";
  public imagePath="";
  //public questionData = { questionType: '', question: '', loadedAnswersForActiveQuestion: [], points:'', rightAnswer:0, answers:[]};
  constructor(public translator:TranslatorService) { }

  ngOnInit() {
    for (let i = 0; i < this.questionData.answers.length; i++) {
      if (this.questionData.answers[i].val === "true") {
        this.rightAnswer += this.questionData.answers[i].label +  ", ";
      }
    }

    this.imagePath = "./../../../../assets/formidabilii/teachers/" + (this.questionData.questionMaterie +1) + ".png";

  }

  public modifyQuestion(mode: string) {
    this.onQuestionClick.emit(mode);
  }

}
